<template>
  <div data-testid="list__root">
    <div class="d-flex align-center" data-testid="list__header">
      <span class="pr-1" data-testid="list__label">{{ label || "List" }}: </span>
      <span class="" v-if="!disabled" data-testid="list__add-wrapper">
        <v-tooltip bottom content-class="tooltip-bottom">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="dialog=true" icon class="shadow-off" data-testid="list__add-trigger">
              <v-icon data-testid="list__add-icon">mdi-plus-circle</v-icon>
            </v-btn>
          </template>
          <span data-testid="list__add-tooltip">Add Item(s)</span>
        </v-tooltip>
      </span>
      <v-spacer data-testid="list__header-spacer"></v-spacer>
      <span class="grey--text pl-1 "
        data-testid="list__count">{{ content.length }} Added</span
      >
    </div>
    <v-dialog
      :max-width="width"
      v-model="dialog"
      transition="dialog-transition"
      ref="dialog"
      eager
      @input="setFocus()"
      data-testid="list__dialog"
    >
      <v-card elevation="0" flat data-testid="list__card">
        <v-card-text class="title pt-3" data-testid="list__card-header">
          <div class="d-flex align-center" data-testid="list__card-header-row">
            <span class="flex-grow-1" data-testid="list__card-title">Add new</span>
            <span class="caption" data-testid="list__card-count">{{ content.length }} Added</span>
          </div>
        </v-card-text>
        <v-card-text class="py-0" data-testid="list__card-body">
          <lb-number
            ref="element"
            v-if="type === 'numberarray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-number"
          />
          <lb-date
            ref="element"
            v-else-if="type === 'datearray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-date"
          />
          <lb-month
            ref="element"
            v-else-if="type === 'montharray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-month"
          />
          <lb-year
            ref="element"
            v-else-if="type === 'yeararray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-year"
          />
          <lb-time
            ref="element"
            v-else-if="type === 'timearray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-time"
          />
          <lb-daterange
            ref="element"
            v-else-if="type === 'daterangearray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-daterange"
          />
          <lb-timerange
            ref="element"
            v-else-if="type === 'timerangearray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-timerange"
          />
          <lb-string
            ref="element"
            v-else-if="type === 'stringarray'"
            v-model="tempContent"
            :hide-details="hidedetails"
            :disabled="disabled"
            data-testid="list__input-string"
          />
        </v-card-text>
        <v-card-text class="text-right" data-testid="list__card-actions">
          <v-btn
            text
            class="mr-1"
           
            @click="
              dialog = false;
              updateValue();
            "
            data-testid="list__close-btn"
            ><span data-testid="list__close-label">close</span></v-btn
          >
          <v-btn
           
            class="mr-1"
            elevation="0"
            color="primary"
            @click="
              addToList();
              dialog = false;
            "
            :disabled="disableAddBtn"
            data-testid="list__add-btn"
            ><span data-testid="list__add-btn-label">Add</span></v-btn
          >
          <v-btn
           
            elevation="0"
            color="primary"
            @click="
              addToList();
              setFocus(0);
            "
            :disabled="disableAddBtn"
            data-testid="list__add-more-btn"
            ><span data-testid="list__add-more-btn-label">Add more</span></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-if="display === 'list'" data-testid="list__list-wrapper">
      <div
        v-for="(v, k) in formattedContent"
        :key="k"
        class="hoverable"
        data-testid="list__list-item"
      >
        <div class="d-flex align-start px-2" data-testid="list__list-item-row">
          <div class="" data-testid="list__list-item-value">{{ v }}</div>
          <v-spacer data-testid="list__list-item-spacer"></v-spacer>
          <v-tooltip bottom content-class="tooltip-bottom" v-if="!disabled" data-testid="list__list-item-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs" v-on="on"
                class="pl-1 pt-1 cursor-pointer"
                @click="deleteItem(k)"
                data-testid="list__list-item-remove"
                >mdi-close-circle</v-icon
              >
            </template>
            <span data-testid="list__list-item-tooltip-label">Remove Item</span>
          </v-tooltip>
        </div>
        <v-divider data-testid="list__divider"></v-divider>
      </div>
    </div>
    <div v-else data-testid="list__chip-wrapper">
      <v-chip v-for="(v, k) in formattedContent" :key="k" class="mb-1 mr-1" data-testid="list__chip">
        <span data-testid="list__chip-label">{{ v }}</span>
        <v-tooltip bottom content-class="tooltip-bottom" v-if="!disabled" data-testid="list__chip-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" right @click="deleteItem(k)" data-testid="list__chip-remove">mdi-close-circle</v-icon>
          </template>
          <span data-testid="list__chip-tooltip-label">Remove Item</span>
        </v-tooltip>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    // lbstring, lbnumber, lbdate, lbtime, lbdaterange, lbtimerange
  },
  created() {
     this.setTemp();
    this.setFormatted();
    if (this.type === "stringarray") this.width = "580px";
    this.updateValue();
  },
  activated() {
    this.setTemp();
    this.setFormatted();
    if (this.type === "stringarray") this.width = "580px";
    this.updateValue();
  },
  data: () => ({
    dialog: false,
    content: [],
    tempContent: "",
    formattedContent: [],
    width: "290px",
  }),
  props: {
    error: {
      type: [String, Array],
    },
    label: {
      type: String,
    },
    value: {
      type: Array,
    },
    type: {
      type: String,
    },
    display: {
      type: String,
    },
    hidedetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowrepeat: {
      type: Boolean,
      default: false,
    },
    // required: {
    //   type: Boolean,
    //   default: false
    // }
  },
  methods: {
    setFocus: function (t = 400) {
      setTimeout(() => {
        if (this.$refs.element) this.$refs.element.setFocus();
      }, t);
    },
    setTemp: function () {
      this.content = this.value || [];
      let arrforlist = ["daterangearray", "timerangearray"];
      if (arrforlist.indexOf(this.type) > -1) this.tempContent = [];
      else this.tempContent = "";
    },
    setFormatted: function () {
      this.formattedContent = [];
      this.content.forEach((el) => {
        this.formattedContent.push(this.formatData(el));
      });
    },
    formatData: function (d) {
      let r = d;
      if (this.type === "daterangearray" || this.type === "datearray") {
        let fc = this.$nova.formatDate(d);
        if (fc instanceof Array) r = fc.join(" - ");
        else r = fc;
      } else if (this.type === "timerangearray" || this.type === "timearray") {
        let fc = this.$nova.formatTime(d);
        if (fc instanceof Array) r = fc.join(" - ");
        else r = fc;
      }
      return r;
    },
    updateValue: function () {
      this.$emit("input", this.content);
      this.$emit("change", this.content);
    },
    addToList: function () {
      let fc = this.formatData(this.tempContent);
      if (fc !== "") {
        if (this.content.indexOf(this.tempContent) === -1 || this.allowrepeat) {
          this.content.push(this.tempContent);
          this.formattedContent.push(fc);
        }
        this.updateValue();
        this.setTemp();
      }
    },
    deleteItem: function (k) {
      this.content.splice(k, 1);
      this.formattedContent.splice(k, 1);
      this.updateValue();
    },
  },
  computed: {
    disableAddBtn() {
      return (
        !(this.tempContent && this.tempContent !== false && this.tempContent.trim() !== '') ||
        (this.tempContent instanceof Array
          ? this.tempContent.length === 0 || this.tempContent.join("") === ""
          : false)
      );
    },
  },
  watch: {
    value: function () {
      this.setTemp();
      this.setFormatted();
    },
  },
};
</script>